//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            invoices: [],
            selectedInvoices: [],
            details: false,
            checkDate: moment().format("MM/DD/YYYY"),
            period: moment(),
            description: '',
            payment: {}
        };
    },


    methods: {
        clickInvoice: function clickInvoice(invoice) {

            if (!this.payment.printed_at) {

                var found = this.selectedInvoices.findIndex(function (inv) {
                    return invoice.number === inv.number;
                });

                if (found < 0) {
                    this.selectedInvoices.push(invoice);
                } else {
                    this.selectedInvoices.splice(found, 1);
                }
            }
        },
        invoiceStatus: function invoiceStatus(invoice) {
            return this.selectedInvoices.find(function (inv) {
                return invoice.number === inv.number;
            }) ? 'selected' : '';
        },
        save: function save() {
            this.payment.description = this.description;
            this.payment.printer = this.printer;
            this.payment.check_date = this.checkDate;
            this.payment.check_period = this.period;
            this.payment.invoices = this.selectedInvoices;
            axios.put('/prototype/accounting/accounts-payable/payments/' + this.payment.id, this.payment).then(function (response) {
                Event.$emit('refresh-payments');
                Event.$emit('close-full-modal');
            });
        },
        APEditPayment: function APEditPayment(payment) {
            var $el = this;
            Object.assign(this.$data, this.$options.data());
            $el.$children[0].$data.showModal = true;
            $el.invoices = [];
            axios.post('/prototype/accounting/accounts-payable/invoice/unpaid').then(function (response) {
                if (response.data) {
                    response.data.map(function (item) {
                        $el.invoices.push(item);
                    });
                }
                $el.loading = false;
            });
            axios.get('/prototype/accounting/accounts-payable/payments/' + payment.id).then(function (response) {
                $el.payment = response.data;
                $el.checkDate = moment($el.payment.check_date).format("MM/DD/YYYY");
                $el.period = moment($el.payment.check_period);
                $el.description = $el.payment.description;
                $el.payment.invoices.map(function (invoice) {
                    $el.selectedInvoices.push(invoice);
                    $el.invoices.push(invoice);
                });
                $el.loading = false;
            });
        }
    },

    computed: {
        total: function total() {
            return this.invoices.reduce(function (sum, item) {
                return sum + parseFloat(item.amount);
            }, 0).toFixed(2);
        },
        totalSelected: function totalSelected() {
            return this.selectedInvoices.reduce(function (sum, item) {
                return sum + parseFloat(item.amount);
            }, 0).toFixed(2);
        }
    },
    created: function created() {
        Event.$on('ap-edit-payment', this.APEditPayment);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('ap-edit-payment');
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/payments/EditPayment.vue
// module id = HIGv
// module chunks = 0 1